<template>
	<el-checkbox
		ref="input"
		class="input-llood-checkbox"
		v-bind="{...$attrs, ...$props}"
		v-model="model">{{label}}</el-checkbox>
</template>

<script>
	export default {
		name: 'InputLloodCheckbox',
		props: {
			value: {
				default: ''
			},
			label:  {
				default: ''
			}
		},
		computed: {

			model: {

				get () { return this.value },

				set (val) { this.$emit('input', val) }

			}

		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) },

			select () { setTimeout(() => this.$refs.input.select(), 200) }
		}
	}
</script>
